import { RouteProp, useRoute } from "@react-navigation/native";
import { CardStyleInterpolators } from "@react-navigation/stack";
import {
  ModalCloseButton,
  createStackHeaderNavigator,
  useThemeProvider,
} from "@towersystems/roam-common-native";
import { useTranslation } from "react-i18next";
import {
  PhotoImageRootParamList,
  ProductImageDetailsRootParamList,
} from "../../../../types";
import { keys } from "../../../../utilities/i18n";
import { PermissionsModalRootScreen } from "../../../permission/screens";
import { ProductImageDetailsScreen } from "../ProductImageDetailsScreen";
import { SelectUploadImageMethodScreen } from "../SelectUploadImageMethodScreen";
import { ProductImageDetailsRootProvider } from "../../components";

export interface ProductImageDetailsRootScreenProps {}

export function ProductImageDetailsRootScreen(
  props: ProductImageDetailsRootScreenProps
) {
  const { t } = useTranslation();
  const { colors } = useThemeProvider();
  const {
    params: { productId },
  } = useRoute<
    RouteProp<PhotoImageRootParamList, "ProductImageDetailsRootScreen"> & {
      params: { productId: string };
    }
  >();

  const Stack = createStackHeaderNavigator<ProductImageDetailsRootParamList>();

  const transparentScreenOptions = {
    headerStyle: {
      backgroundColor: colors.surface,
    },
    cardStyle: {
      backgroundColor: "transparent",
    },
    headerShown: false,
    animationEnabled: true,
    presentation: "transparentModal",
    cardStyleInterpolator: CardStyleInterpolators.forModalPresentationIOS,
  } as const;

  return (
    <ProductImageDetailsRootProvider productId={productId}>
      <Stack.Navigator
        detachInactiveScreens={true}
        screenOptions={{
          title: "",
          headerLeft: () => <ModalCloseButton type="Back" />,
          cardStyleInterpolator: CardStyleInterpolators.forHorizontalIOS,
        }}
      >
        <Stack.Screen
          name="ProductImageDetailsScreen"
          component={ProductImageDetailsScreen}
          options={{
            headerLeft: () => <ModalCloseButton type="Back" />,
            title:'',
          }}
        />
        <Stack.Screen
          name="SelectUploadImageMethodScreen"
          component={SelectUploadImageMethodScreen}
          options={{
            headerShown: false,
            cardStyle: { height: "100%", backgroundColor: "#000" },
          }}
        />
        <Stack.Group screenOptions={transparentScreenOptions}>
          <Stack.Screen
            name="PermissionsModalRootScreen"
            component={PermissionsModalRootScreen}
          />
        </Stack.Group>
      </Stack.Navigator>
    </ProductImageDetailsRootProvider>
  );
}
